// extracted by mini-css-extract-plugin
module.exports = {"root":"_1hdoh","inner":"_39H15","icon":"KofQM","details":"_3sALZ","subtitle":"_3J8bi","title":"_1veKP","rightSide":"_13eHR","small":"_2o_fE","rightSize":"_1BZGX"};